var _path, _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDetails = function SvgDetails(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#788D94",
    d: "M15.206 1.108H4.794A2.765 2.765 0 0 0 2.02 3.882v12.502a2.78 2.78 0 0 0 2.774 2.775h10.43A2.78 2.78 0 0 0 18 16.384V3.882a2.794 2.794 0 0 0-2.793-2.774Zm1.197 15.275c0 .665-.532 1.197-1.197 1.197H4.794a1.19 1.19 0 0 1-1.197-1.197V3.882c0-.665.532-1.197 1.197-1.197h10.43c.666 0 1.198.532 1.198 1.197v12.501z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 8.493,
    height: 1.584,
    x: 5.763,
    y: 5.565,
    fill: "#788D94",
    rx: 0.792
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 8.493,
    height: 1.584,
    x: 5.763,
    y: 9.34,
    fill: "#788D94",
    rx: 0.792
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 6.343,
    height: 1.584,
    x: 5.763,
    y: 13.116,
    fill: "#788D94",
    rx: 0.792
  })));
};
export default SvgDetails;